import { Button } from "@mui/material";
import React from "react";
import { ColorsConstants } from "../cssUtils/constants";

const ButtonThree = ({
  onClick,
  startIcon = null,
  endIcon = null,
  children,
  sx = {},
  variant = "outlined",
  ...props
}) => {
  return (
    <Button
      variant={variant}
      size="medium"
      onClick={onClick}
      startIcon={startIcon}
      endIcon={endIcon}
      sx={{
        borderRadius: "8px",
        fontSize: 14,
        height: 40,
        textTransform: "none",

        /* ✅ Proper border fix */
        border: `1px solid ${ColorsConstants.inputFieldGrey}`,
        color: "#000000DE",

        "&:hover": {
          border: `1px solid ${ColorsConstants.primaryGray50}`,
          backgroundColor: "transparent",
        },

        "&.Mui-focusVisible": {
          border: `1px solid ${ColorsConstants.primaryGray50}`,
        },

        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default ButtonThree;